import { render, staticRenderFns } from "./ClaimDetail.vue?vue&type=template&id=6c0d0046"
import script from "./ClaimDetail.vue?vue&type=script&lang=js"
export * from "./ClaimDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports